// =====================================================
// APPWITHTHEME.TSX - WRAPPER CON THEMEPROVIDER
// =====================================================

import React from 'react'
import App from './App'
import { ThemeProvider } from './contexts/ThemeContext'

const AppWithTheme: React.FC = () => {
  return (
    <ThemeProvider>
      <App />
    </ThemeProvider>
  )
}

export default AppWithTheme